import { connect } from 'react-redux';
import Canvas from './canvas';
import {
  moveWorkTo, setCenter, recalculateDpis, resetCenter
} from '../../actions/canvas';
import { moveCustomImage } from '../../actions/custom_image';
import { show } from '../../actions/current_index';

const mapStateToProps = (state) => {
  const {
    canvas, customImage, wallPaper, workDetails, grids
  } = state;
  return {
    ...canvas,
    customImage,
    wallPaper,
    workDetails,
    grids
  };
};

export default connect(mapStateToProps, {
  moveWorkTo, setCenter, moveCustomImage, showWorkDetails: show, recalculateDpis, resetCenter
})(Canvas);
